<template>
  <div class="app-main-content write-off">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width: 100%;">
        <el-tab-pane :label="$t('WriteOff.nonWriteoffList')" name="nonWriteOffList">
          <tab-non-write-off-list />
        </el-tab-pane>
        <el-tab-pane :label="$t('WriteOff.writeoffList')" name="writeOffList" :lazy="true">
          <tab-write-off-list />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabWriteOffList from './components/Writeoff/tabWriteOffList'
import tabNonWriteOffList from './components/Writeoff/tabNonWriteOffList'

export default {
  name: 'WriteOff',
  components: { tabWriteOffList, tabNonWriteOffList },
  data() {
    return {
      activeTabName: 'nonWriteOffList'
    }
  }
}
</script>

<style lang="scss">
.write-off {
  //.el-tabs__content {
  //  padding: 0 !important;
  //  background: #fff;
  //}
  //.dense-radio-group {
  //  .el-form-item {
  //    margin-bottom: 0 !important;
  //    .el-form-item__content {
  //      vertical-align: middle;
  //    }
  //  }
  //  .el-radio {
  //    margin-right: 6px !important;
  //    .el-radio__label {
  //      padding-left: 4px!important;
  //    }
  //  }
  //}
  //.total-detail-popover {
  //  display: flex;
  //  align-items: center;
  //  justify-content: center;
  //  >span {
  //    padding-right: 6px;
  //  }
  //}
}
</style>
